// 应用级配置模块：标题、环境和接口地址从环境变量中读取。
const app = {
    namespaced: true,

    state() {
        return {
            name: process.env.VUE_APP_TITLE || 'Vue3 Webpack App',
            env: process.env.VUE_APP_ENV || 'development',
            apiBaseUrl: process.env.VUE_APP_API_BASE_URL || '/api',
        }
    },

    mutations: {
        SET_NAME(state, name) {
            state.name = name
        },
    },
}

export default app
